

























import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            title: 'MessageDesk has been updated.',
            text: 'Refresh the page to make it yours.'
        }
    },
    computed: {
        clientDeployedPopup() {
            return this.$store.getters.clientDeployedPopup
        }
    },
    methods: {
        dismiss() {
            //  Close the popup
            this.$store.commit('clientDeployedPopupSet', false)
        },
        reload() {
            //  Close the popup
            this.dismiss()

            //  Reload the window
            location.reload()
        }
    }
})
